"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var LoginPageState_1 = require("./LoginPageState");
var CommonFunctions_1 = require("../common/CommonFunctions/CommonFunctions");
var LoginConsole_1 = require("../LoginConsole");
var LoginConsoleProps_1 = require("../LoginConsole/LoginConsoleProps");
var LoginConfiguration_1 = require("../../services/LoginConfiguration");
var CommonSpinner_1 = require("../common/CommonSpinner");
var SessionRefreshService_1 = require("../../services/SessionRefreshService");
var HalocAuthenticationService_1 = require("../../services/HalocAuthenticationService");
var FeatureToggleService_1 = require("../../services/FeatureToggleService");
/** Api, Reporting, Mappers, Request, Response */
var FEATURE_TOGGLE_IDP_LOGIN_ENABLED = 'svc-idm-login-on-idp';
var LoginPage = /** @class */ (function (_super) {
    __extends(LoginPage, _super);
    function LoginPage(props) {
        var _this = _super.call(this, props) || this;
        _this.commonFunctions = CommonFunctions_1.CommonFunctions.getInstance();
        _this.refreshFlow = false;
        _this.nativeWebView = false;
        _this.halocAuthenticateionService = new HalocAuthenticationService_1.default();
        _this.postAuthError = false;
        var state = new LoginPageState_1.default();
        _this.clientId = _this.commonFunctions.isTestEnv() ?
            LoginConfiguration_1.default.haloCServicesMechIdTest :
            LoginConfiguration_1.default.haloCServicesMechIdProd;
        if (_this.commonFunctions.getQueryParam('refresh') === 'true') {
            state.doingSessionRefresh = true;
            _this.refreshFlow = true;
            new SessionRefreshService_1.default(_this.props)
                .refresh().then(function () {
                _this.setState({
                    doingSessionRefresh: false,
                });
            });
        }
        var intentParam = _this.commonFunctions.getQueryParam('intent');
        if (_this.commonFunctions.notBlankCheck(intentParam)) {
            state.intentCheck = true;
            _this.handleIntent(intentParam);
        }
        _this.postAuthError = _this.commonFunctions.getQueryParam('postAuthError') != null;
        // Have cAuthNState, do not have an error and either flag is present
        // we run the app shell check to make sure the login wasn't sales/support
        if ((sessionStorage.getItem("appshell.halo.redirect.flag.halocLoginRedirectionDone") !== null ||
            sessionStorage.getItem("appshell.halo.redirect.flag.halocIsPassiveRedirection") !== null) &&
            document.cookie.indexOf('cAuthNState') !== -1 &&
            !_this.postAuthError) {
            state.doingSessionRefresh = true;
            // Run the app shell checks
            _this.halocAuthenticateionService.checkHalocAuth('login', _this.clientId)
                .then(function () {
                _this.setState({
                    doingSessionRefresh: false,
                });
            });
        }
        // Skipping the invalidation if native flow
        if (_this.commonFunctions.getQueryParam('native') === 'true') {
            _this.nativeWebView = true;
        }
        _this.state = state;
        _this.loginConsoleComplete = _this.loginConsoleComplete.bind(_this);
        _this.initializeEvents();
        return _this;
    }
    LoginPage.prototype.handleIntent = function (intent) {
        return __awaiter(this, void 0, void 0, function () {
            var intentDisabled, value, redirectUrl;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, FeatureToggleService_1.default.
                            checkFeatureToggleEnabled('svc-login-disable-intent-redirect')];
                    case 1:
                        intentDisabled = _a.sent();
                        console.log('svc-login-disable-intent-redirect', intentDisabled);
                        if (intentDisabled) {
                            this.setState({
                                intentCheck: false,
                            });
                            return [2 /*return*/];
                        }
                        else {
                            value = encodeURIComponent(intent);
                            redirectUrl = "/acctmgmt/signin?intent=" + value;
                            window.location.href = redirectUrl;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    LoginPage.prototype.initializeEvents = function () {
        this.loginConsoleEvents = {
            loginConsoleComplete: this.loginConsoleComplete,
        };
    };
    LoginPage.prototype.componentDidMount = function () {
        this.setDynatraceTrackingCookie();
    };
    LoginPage.prototype.setDynatraceTrackingCookie = function () {
        try {
            var date = new Date();
            // 5 minute expiration
            date.setTime(date.getTime() + (5 * 60 * 1000));
            document.cookie = "dtlgnsrc=acctmgmt; path=/; domain=.att.com; expires=" + date.toUTCString();
        }
        catch (e) {
            console.error('Exception setting a dtlgnsrc cookie', e);
        }
    };
    LoginPage.prototype.clearIDPSessionStorage = function () {
        try {
            sessionStorage.removeItem('halo.token.validated.for');
            sessionStorage.removeItem('halocIsPassiveRedirection');
            sessionStorage.removeItem('halocLoginRedirectionDone');
            sessionStorage.removeItem('appshell.halo.redirect.flag.halocIsPassiveRedirection');
            sessionStorage.removeItem('appshell.halo.redirect.flag.halocLoginRedirectionDone');
            sessionStorage.removeItem('halo.reg.forgot.actionType');
        }
        catch (e) {
            console.info('login-ui: error clearing session storage', e);
        }
    };
    LoginPage.prototype.loginConsoleComplete = function (status) {
        console.log('login-ui::loginConsoleComplete::', status);
        var targetUrl = this.commonFunctions.getTargetUrl();
        if (this.postAuthError) {
            console.log("login-ui::loginConsoleComplete displaying post auth error message, don't fire complete");
            return;
        }
        // We are all set, hand off to overview intercept manager
        if (status.authenticated) {
            if (this.commonFunctions.notBlankCheck(targetUrl)) {
                window.location.href = targetUrl;
            }
            else {
                if (this.props && this.props.data && this.props.data.commonuiLoginExperienceUtil) {
                    console.log('login-ui::loginConsoleComplete calling loginExperienceUtil.callLoginExpAndRedirect');
                    this.props.data.commonuiLoginExperienceUtil.callLoginExpAndRedirect();
                }
                else if (this.props && this.props.history && this.props.history.push) {
                    this.props.history.push('/loginexp');
                }
                else {
                    window.location.assign('/acctmgmt/loginexp');
                }
            }
        }
        else if (this.nativeWebView && this.commonFunctions.notBlankCheck(targetUrl)) {
            console.log("login-ui::LoginPage nativeWebView set calling targetUrl with canceled=true");
            var sep = targetUrl.indexOf('?') > -1 ? '&' : '?';
            if (status.errorMessage) {
                window.location.href = targetUrl + sep + 'error=true&error_message='
                    + encodeURIComponent(status.errorMessage);
            }
            else {
                window.location.href = targetUrl + sep + 'canceled=true';
            }
        }
        else {
            this.clearIDPSessionStorage();
            // If not authenticated, make sure we logout before trying to come back.
            console.log("login-ui::LoginPage user not authenticated, triggering full logout");
            var logoutBase = this.commonFunctions.getHaloCLogoutUrlForEnv();
            if (this.commonFunctions.notBlankCheck(targetUrl)) {
                window.location.href = logoutBase + encodeURIComponent(targetUrl);
            }
            else {
                var port = window.location.port ? ':' + window.location.port : '';
                var host = window.location.hostname + port;
                var doLoginUrl = window.location.protocol + '//' + host + '/acctmgmt/login';
                window.location.href = logoutBase + encodeURIComponent(doLoginUrl);
            }
        }
    };
    LoginPage.prototype.render = function () {
        if (this.state.intentCheck || this.state.doingSessionRefresh) {
            return (React.createElement("div", null,
                React.createElement(CommonSpinner_1.default, null)));
        }
        else {
            return (React.createElement("div", null,
                React.createElement(LoginConsole_1.default, { data: {
                        channel: 'acctmgmt',
                        flowType: LoginConsoleProps_1.FlowType.SERVICES,
                        haloClientId: this.clientId,
                    }, options: {
                        skipInvalidateOnCancel: this.nativeWebView,
                    }, events: this.loginConsoleEvents })));
        }
    };
    return LoginPage;
}(React.Component));
exports.default = LoginPage;
//# sourceMappingURL=LoginPage.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/LoginPage/LoginPage.js
// module id = 1691
// module chunks = 8